<footer class="footer" [dir]="'Direction' | translate">
  <div class="container">
    <div class="row">
      <!-- Logo and Contact Information -->
      <div class="col-md-4 text-center">
        <img src="assets/images/logo.jpeg" alt="{{ 'footer.logoAlt' | translate }}" class="footer-logo mb-4"
          style="background-color: white;">
        <!-- <p class="company-description">
          {{ 'footer.companyDescription' | translate }}
        </p> -->
        <ul class="footer-contact-info">
          <li>
            <i class="fas fa-map-marker-alt"></i> {{ 'footer.contact.address' | translate }}
          </li>
          <li>
            <i class="fas fa-phone"></i> {{ 'footer.contact.phone' | translate }}
          </li>
          <li>
            <i class="fas fa-code-branch"></i> <a [routerLink]="'/contact'">{{ 'footer.contact.branches' | translate
              }}</a>
          </li>
          <li>
            <i class="fas fa-envelope"></i> <a href="mailto:{{ 'footer.contact.email' | translate }}">{{
              'footer.contact.email' | translate }}</a>
          </li>

        </ul>
      </div>

      <!-- Company Links -->
      <div class="col-md-4">
        <div class="footer-title">{{ 'footer.companyLinks' | translate }}</div>
        <div class="footer-links-container">
          <ul class="footer-links">
            <li><a [routerLink]="'/home'">{{ 'Header.Item1' | translate }}</a></li>
            <li><a [routerLink]="'/reports'">{{ 'Header.Item4' | translate }}</a></li>
            <li><a [routerLink]="'/news'">{{ 'Header.Item3' | translate }}</a></li>
            <li><a [routerLink]="'/market-watch'">{{ 'Header.Item2' | translate }}</a></li>
            <li><a [routerLink]="'/market-statistics'">{{ 'Header.Item5' | translate }}</a></li>
          </ul>
          <ul class="footer-links">
            <li><a [routerLink]="'/stocks-information'">{{ 'Header.Item8' | translate }}</a></li>
            <li><a [routerLink]="'/agenda'">{{ 'Header.Item7' | translate }}</a></li>
            <li><a [routerLink]="'/portfolio-holdings'">{{ 'Header.Item14' | translate }}</a></li>
            <li><a [routerLink]="'/contact-us'">{{ 'Header.Item6' | translate }}</a></li>
            <li><a [routerLink]="'/privacy'">{{ 'TermsAndConditions.Title' | translate }}</a></li>
            <li><a [routerLink]="'/cookies-policy'">{{ 'CookiePolicy.Title' | translate }}</a></li>
          </ul>
        </div>
        <div class="footer-find-us">
          <div class="footer-title">{{ 'footer.social.findUsOn' | translate }}</div>
          <div>
            <a id="ctl00_hlnl_iinvest" href="http://www.iinvest.gov.eg/general/index.jsp" target="_blank" tabindex="0">
              <img id="ctl00_imgIinvest" class="ImgIinvest" src="assets/images/I-invest.png" style="border-width:0px;">
            </a>
          </div>
        </div>
        <div class="footer-social-icons">
          <a href="https://www.facebook.com/PioneersSecurities" target="_blank"><i class="fab fa-facebook-f"></i></a>
          <a href="https://x.com/PioSec/" target="_blank"><i class="fab fa-twitter"></i></a>
          <!-- <a href="hhttps://open.spotify.com/show/4bScgs3LywR2KFj4lotZ3S?si=47dc17ad801f4905" target="_blank"><i class="fab fa-spotify"></i></a> -->
          <a href="https://whatsapp.com/channel/0029Va21eln1iUxR3gxiq01l" target="_blank"><i
              class="fab fa-whatsapp"></i></a>
          <a href="https://t.me/+qj0TIQiOvihmM2E0" target="_blank"><i class="fab fa-telegram"></i></a>
          <a href="https://www.tiktok.com/@pioneerssecurities?fbclid=IwY2xjawEm075leHRuA2FlbQIxMAABHX3TWgKXNCzjyxf1W7YBbEwPAFexw1ltgjYuOwqXAcXI9wW7PpJqa2D7rg_aem_3fIWGQsik_WQOyU17yj9tg"
            target="_blank"><i class="fab fa-tiktok"></i></a>
          <a href="https://www.instagram.com/pioneers.securities/" target="_blank"><i class="fab fa-instagram"></i></a>
          <a href="https://play.google.com/store/apps/details?id=com.fitoman.piogo&hl=en" target="_blank"><i
              class="fab fa-google-play"></i></a>
          <a href="https://apps.apple.com/eg/app/pioneers-go/id6739808913" target="_blank"><i
              class="fab fa-apple"></i></a>
        </div>
      </div>



      <!-- Quick Contact Form -->
      <div class="col-md-4">
        <div class="footer-title">{{ 'footer.contactForm.quickContact' | translate }}</div>
        <form class="footer-contact-form" [formGroup]="contactFooterForm" (ngSubmit)="onFooterFormSubmit()">

          <!-- Name Field -->
          <input type="text" formControlName="name" placeholder="{{ 'footer.contactForm.name' | translate }}" required>
          <div *ngIf="contactFooterForm.get('name').invalid &&  contactFooterForm.get('name').touched"
            class="invalid-feedback">
            <small *ngIf="contactFooterForm.get('name').hasError('required')">
              {{ 'footer.contactForm.nameRequired' | translate }}
            </small>
          </div>

          <!-- Email Field -->
          <input type="email" formControlName="email" placeholder="{{ 'footer.contactForm.email' | translate }}"
            required>
          <div *ngIf="contactFooterForm.get('email').invalid && contactFooterForm.get('email').touched"
            class="invalid-feedback">
            <small *ngIf="contactFooterForm.get('email').hasError('required')">
              {{ 'footer.contactForm.emailRequired' | translate }}
            </small>
            <small *ngIf="contactFooterForm.get('email').hasError('email')">
              {{ 'footer.contactForm.emailInvalid' | translate }}
            </small>
          </div>

          <!-- Message Field -->
          <textarea formControlName="message" placeholder="{{ 'footer.contactForm.message' | translate }}"
            required></textarea>
          <div *ngIf="contactFooterForm.get('message').invalid && contactFooterForm.get('message').touched"
            class="invalid-feedback">
            <small *ngIf="contactFooterForm.get('message').hasError('required')">
              {{ 'footer.contactForm.messageRequired' | translate }}
            </small>
          </div>

          <!-- reCAPTCHA -->
          <re-captcha (resolved)="onFooterCaptchaResolved($event)" [siteKey]="siteKey">
          </re-captcha>

          <!-- Submit Button -->
          <button type="submit" [disabled]="!recaptchaToken">
            {{ 'footer.contactForm.send' | translate }}
          </button>
        </form>

        <!-- Submission Message -->
        <div *ngIf="message" class="mt-3 alert" [ngClass]="messageClass">{{ message | translate }}</div>
      </div>

    </div>
  </div>
  <div class="footer-bottom text-center py-3">
    <div class="container">
      <div>{{ 'footer.copyright' | translate }}</div>
    </div>
  </div>
</footer>